import React, {FC} from 'react';
import {FileOutlined} from '@ant-design/icons';

import {
    INFO_RENINS,
    OFFER_FIN,
    OFFER_LAW, OFFER_LAW_MKK,
    OFFER_MED,
    OFFER_MED_ONLINE, OFFER_MOBILE_SECURITY, OFFER_PPM, OFFER_PPM_ADD,
    POLICY, RULES_SMS_INFO
} from '../../config/routes';
import {Contacts} from '../index/Contacts/Contacts';

import cls from './Document.module.scss'

const Document: FC = () => (
        <div className={'content'}>
            <div className={cls.page}>
                <h2>Документы</h2>
                <p><a href={POLICY} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Политика конфиденциальности</a>
                </p>
                <p><a href={OFFER_FIN} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта «Финансовая защита»</a>
                </p>
                <p><a href={OFFER_MED} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта Правила абонентского
                    обслуживания, онлайн консультация с врачом</a></p>
                <p><a href={OFFER_MED_ONLINE} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта «Медицина
                    онлайн»</a></p>
                <p><a href={OFFER_LAW} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта Правила абонентского
                    обслуживания, Телеюрист</a></p>
                <p><a href={OFFER_LAW_MKK} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта Правила абонентского
                    обслуживания, Телеюрист, МКК</a></p>
                <p><a href={RULES_SMS_INFO} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Правила предоставления
                    услуги СМС-информирование</a></p>
                <p><a href={INFO_RENINS} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Информация о компании ПАО
                    «Группа Ренессанс Страхование»</a></p>
                {/*<p><a href={OFFER_ASTRO} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта Правила абонентского обслуживания, Телеастролог</a></p>*/}
                <p><a href={OFFER_PPM} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта «Помощь
                    пострадавшим от мошенников»</a></p>
                <p><a href={OFFER_PPM_ADD} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Правила продукта «Помощь
                    пострадавшим от мошенников» (дополнение к сертификату)</a></p>
                <p><a href={OFFER_MOBILE_SECURITY} target={'_blank'} rel={'noreferrer'}><FileOutlined/> Оферта «Мобильная Защита»</a></p>
            </div>
            <Contacts/>
        </div>
)

export default Document;



